<template>
	<v-layout row wrap class="mb-5">
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-4">What does this space offer guests?</p>
			<choice-field-input 
				:selectionOptions="getOptions"
				:storeSelections="getAddLocationProp('locationInfo')"
				:storeInputs="getAddLocationProp('locationInfoInputs')"
				selectionProp="locationInfo"
				selectionInputProp="locationInfoInputs"
				:mutation="getMutation">
			</choice-field-input>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-content">Many guests are looking for specific space amenities when they make their decision about where to work.</p>
					<p class="add-event-tip-content">We recommend you check all that apply to help guests know that you have what they need!</p>
					<p class="add-event-tip-content">The essentials?  In most cases great WiFi speed, clean bathroom(s), kitchen access, and easy parking options!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-content">Many guests are looking for specific space amenities when they make their decision about where to work.</p>
					<p class="add-event-tip-content">We recommend you check all that apply to help guests know that you have what they need!</p>
					<p class="add-event-tip-content">The essentials?  In most cases great WiFi speed, clean bathroom(s), kitchen access, and easy parking options!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { locationInfoOptions } from '~/store/util/values'
import * as TYPE from '~/store/util/types'
import ChoiceFieldInput from '~/components/ChoiceFieldInput'
export default {
	data() {
		return {}
	},
	components: {
		ChoiceFieldInput: ChoiceFieldInput
	},
	beforeRouteLeave(to, from, next) {
		this.setAddLocationValidStep(from.path)
		next()
	},
	methods: {
		...mapActions(['setAddLocationProp', 'setAddLocationValidStep'])
	},
	computed: {
		...mapGetters(['getAddLocationProp', 'getEventTags']),
		getMutation() {
			return TYPE.SET_LOCATION_PROP
		},
		getOptions() {
			return locationInfoOptions
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
